import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the credit-notes sub-tree (register at `/sales-invoicing/
 * credit-notes`, create at `/sales-invoicing/credit-notes/new`, detail at
 * `/sales-invoicing/credit-notes/$creditNoteId`) — mirrors `silo-counts/
 * counts.tsx`'s identical pattern. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/credit-notes')({
  component: () => <Outlet />,
});
